<template>
	<div id='iframe_pl'>
		<h1 style='text-align:center'>{{ settingObj.name }} : Préférences
			<button id="btnExport_pref" title="Télécharger le fichier de préférences" class="mdl-button mdl-js-button mdl-button--icon" @click='downloadPLPref()' ><i class="material-icons">file_download</i></button>
		</h1>
		<webView :settingId="settingObj.id" path="/preferences" @msg="handleMessageWebViewFrame" />
	</div>
</template>

<script>
	import { diagonalbackURL, OctetStreamConfig } from "../constantes";
	import axios from 'axios';
	import FctUtils from '@/components/FctUtils';
	import WebView from '@/components/WebViewProLexis';

	export default { 
		name: "PreferencesFrame",
		mixins: [FctUtils],
		components: {
			'webView' : WebView,
		},
		props: {
			settingObjStr:{ type: String }
		},
		data(){
			return {
				PLName:"Préférences [ProLexis]",
				settingObj: {}
			}
		},
		created() {
			// Si pas de settings, on regarde s'il n'y en a pas un déjà dans le store
			//
			if (!FctUtils.methods.noEmpty(this.settingObjStr)) {
				this.settingObj = this.$store.getters.setting;
			}
			else {
				this.settingObj = JSON.parse(this.settingObjStr);
			}

			// Si pas de setting, on retourne à la sélection.
			//
			if (! FctUtils.methods.noEmpty(this.settingObj)) {
				this.$router.push({name:"SelectDicoSetting", params: { from: "PreferencesFrame"}});
			}
		},
		methods : {
			handleMessageWebViewFrame(iEvent, iSrcEvent)
			{
				switch(iEvent.msg) {
					// Une préférence est désactivée (pas encore faite pour le WebService)
					//
					case 'unavailable':
						this.emitter.emit('showPopup', {
							mode:  'error_custom',
							title: 'Néologismes',
							text:  'La personnalisation des néologismes n’est actuellement pas disponible.',
						});
					break;

					// Affichage des variantes
					//
					case 'variants':
						this.$router.push({ name: 'VariantsFrame', params: { displayType: (iEvent.name == 'VAR_USR_LINK' ? 1 : 0), settingObjStr : JSON.stringify(this.settingObj) } });
					break;
				}
			},
			downloadPLPref() {
                var url = diagonalbackURL + "/settings/"+ this.settingObj.id + "/preferences/prolexis";

                axios(url, OctetStreamConfig)
                .then(response => {
                    this.downloadFile(this.PLName, response.data);
                })
                .catch(async error => {
                    const errorCatched = await FctUtils.methods.areSettingsLocked(error);

                    if (errorCatched) {
                        this.emitter.emit('showPopup', {mode: 'error_maj'});
                    }
                    this.errorHandler(error)
                });
            },
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#iframe_pl {
	height : calc(100% - 0px);
}

#btnExport_pref {
    color: #0075bb;
	margin-top : 8px;
	float: right;
}

</style>
